import { combineReducers, configureStore } from '@reduxjs/toolkit'
import colorSlice from './feature/colorSlice'
import patternSlice from './feature/patternSlice'
import currencySlice from './feature/currencySlice'
import operationSlice from './feature/operationSlice'
import locationSlice from './feature/locationSlice'
import weightSlice from './feature/weightSlice'
import productSlice from './feature/productSlice'
import supplierSlice from './feature/supplierSlice'
import outsourcerSlice from './feature/outsourcerSlice'
import customerSlice from './feature/customerSlice'
import purchaseSlice from './feature/purchaseSlice'
import orderSlice from './feature/orderSlice'
import rollSlice from './feature/rollSlice'
import accountSlice from './feature/accountSlice'
import paymentSlice from './feature/paymentSlice'
import searchParamsSlice from './feature/searchParamsSlice'
import authSlice from './feature/authSlice'

const rootReducer = combineReducers({
    color: colorSlice.reducer,
    pattern: patternSlice.reducer,
    currency: currencySlice.reducer,
    operation: operationSlice.reducer,
    location: locationSlice.reducer,
    weight: weightSlice.reducer,
    product: productSlice.reducer,
    supplier: supplierSlice.reducer,
    outsourcer: outsourcerSlice.reducer,
    customer: customerSlice.reducer,
    purchase: purchaseSlice.reducer,
    order: orderSlice.reducer,
    roll: rollSlice.reducer,
    account: accountSlice.reducer,
    payment: paymentSlice.reducer,
    searchParams: searchParamsSlice.reducer,
    auth: authSlice.reducer

})

export const setupStore = () => {
    return configureStore({
        reducer: rootReducer
    })
}